import React, { 
    // useContext, 
    useMemo } from "react";
import { motion } from "framer-motion";
import { IntersectionObserver } from "./intersectionObserver";
import { StaggerWrap } from "./Staggerwraps";
// import {
//   IntersectionContext,
//   IntersectionObserver
// } from "./intersectionObserver";

const FadeInUp = ({
  children,
  reset = true,
  duration = 2,
  delay,
  easing = [0,.48,.12,.98],
  className
}) => {
//   const { inView } = useContext(IntersectionContext);
  const transition = useMemo(
    () => ({
      duration,
      ease: easing,
      delay: delay
    }),
    [duration, easing, delay]
  );

  const variants = {
    hidden: {
      opacity: 0,
      y: 50,
      transition
    },
    show: {
      opacity: 1,
      y: 0,
      transition
    }
  };

  return (
    <IntersectionObserver reset={true}>
        <StaggerWrap delay={delay}>
            <motion.div
            variants={variants}
            className={className}
            >
                {children}
            </motion.div>
        </StaggerWrap>
    </IntersectionObserver>
        
  );
};

export const Transition = ({ children, duration, delay, className="overflow-hidden" }) => <FadeInUp duration={duration} delay={delay} className={className}>{children}</FadeInUp>;
